import { useEffect, useState } from 'react';

import useInterval from './use-interval';

/**
 * The current time, re-read on an interval, for clocks which count on their
 * own rather than off the signed-in user's timer.  Held once by whatever shows
 * several of them, so a tick re-renders that one place instead of each clock.
 */
export default function useNow(intervalMs: number | null): Date {
  const [now, setNow] = useState(() => new Date());

  useInterval(() => setNow(new Date()), intervalMs);

  // Picks the clock back up where it should be after a spell of not ticking.
  useEffect(() => setNow(new Date()), [intervalMs]);

  return now;
}
